import { render, staticRenderFns } from "./Type2View.vue?vue&type=template&id=9f9468d0&"
import script from "./Type2View.vue?vue&type=script&lang=js&"
export * from "./Type2View.vue?vue&type=script&lang=js&"
import style0 from "./Type2View.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports